module.exports = __webpack_public_path__ + "static/media/question-inactive.fc7a40a1.svg";